// src/i18n/en/views/iframes.js
export const iframes = {
  pricing: {
    title: "Calculadora de preços",
    description:
      "Configure preços base e adicionais por unidade em cada plano; as faturas mostram o imposto em uma linha separada.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Vídeo: Calculadora de preços (EN)",
  },
  connectBooking: {
    title: "Conectar Booking.com",
    description:
      "Guia passo a passo para vincular sua propriedade ao Booking.com pelo Gerenciador de Canais.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Vídeo: Conectar Booking.com (EN)",
  },
  connectAirbnb: {
    title: "Conectar Airbnb (via Channex)",
    description:
      "Ative a conexão com o Airbnb a partir do seu PMS usando o Channex e sincronize disponibilidade e tarifas.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Vídeo: Conectar Airbnb (EN)",
  },
  channexCertification: {
    title: "Certificação Channex · PMS",
    description:
      "Requisitos e testes para concluir a certificação PMS com o Channex (sincronização completa, preços, restrições).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Vídeo: Certificação Channex (EN)",
  },
  hotelCalendar: {
    title: "Calendário do hotel (multiquartos)",
    description:
      "Gerencie reservas por tipo de quarto e instância; evite overbookings com uma visão estruturada.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Vídeo: Calendário do hotel (EN)",
  },
  apartmentCalendar: {
    title: "Calendário de apartamentos",
    description:
      "Bloqueios, preços por dia e estadias em um calendário por propriedade.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Vídeo: Calendário de apartamentos (EN)",
  },
  guestCheckin: {
    title: "Check-in por WhatsApp",
    description:
      "Os hóspedes escaneiam o documento, passam pela verificação de identidade e assinam digitalmente pelo celular.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Vídeo: Check-in por WhatsApp (EN)",
  },
  identityVerification: {
    title: "Verificação de identidade e assinatura eletrônica",
    description:
      "Verificação por selfie, leitura de MRZ/PDF417 e assinatura eletrônica segura para conformidade.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Vídeo: Verificação de identidade (EN)",
  },
  smartLocks: {
    title: "Fechaduras inteligentes",
    description:
      "Envie códigos de acesso automáticos—sem chaves nem esperas. Compatível com códigos dinâmicos.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Vídeo: Fechaduras inteligentes (EN)",
  },
  reviewsAutomation: {
    title: "Automação de avaliações",
    description:
      "Programe lembretes de avaliação e aumente a reputação da sua propriedade.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Vídeo: Automação de avaliações (EN)",
  },
};
